function peachpayUpdateCurrencyCookie(newCurrency: string) {
	document.cookie = `pp_active_currency=${newCurrency};path=/`;
}

export {peachpayUpdateCurrencyCookie};
